import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';

import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Advantages from './pages/Advantages';
import Product from './pages/Product';
import News from './pages/News';
import NewsDetail from './components/NewsDetail';
import ContactUs from './pages/ContactUs';
import Home_en from './pages/Home_en';
import AboutUs_en from './pages/AboutUs_en';
import Advantages_en from './pages/Advantages_en';
import Product_en from './pages/Product_en';
import News_en from './pages/News_en';
import NewsDetail_en from './pages/NewsDetail_en';
import ContactUs_en from './pages/ContactUs_en';
import NotFound from './pages/NotFound';
import NotFound_en from './pages/NotFound_en';

function AppContent() {
  const location = useLocation();
  const isEnglish = location.pathname.startsWith('/en');

  return (
    <div className={isEnglish ? 'lang-en' : ''}>
      <Header />
      <div className="bg-orb" style={{ width: '400px', height: '400px', top: '-10%', right: '-5%' }} />
      <div className="bg-orb" style={{ width: '300px', height: '300px', bottom: '10%', left: '-5%' }} />

      <Routes>
          <Route path="/" element={<Home />} /> {/* 或設定一個首頁 */}
          <Route path="/about" element={<AboutUs />} />
          <Route path="/advantages" element={<Advantages />} />
          <Route path="/product" element={<Product />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<NewsDetail />} />
          <Route path="/contact" element={<ContactUs />} />

          <Route path="/en" element={<Home_en />} />
          <Route path="/en/about" element={<AboutUs_en />} />
          <Route path="/en/advantages" element={<Advantages_en />} />
          <Route path="/en/product" element={<Product_en />} />
          <Route path="/en/news" element={<News_en />} />
          <Route path="/en/news/:slug" element={<NewsDetail_en />} />
          <Route path="/en/contact" element={<ContactUs_en />} />

          <Route path="/en/*" element={<NotFound_en />} />
          <Route path="*" element={<NotFound />} />
        </Routes>

        <Footer />
      </div>
    );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;
